import { FC, ReactNode } from 'react'
import List from 'components/atoms/List'
import * as styles from 'styles/atoms/TableOfContents.css'

type TableOfContentsProps = {
  title: ReactNode
  isOrdered?: boolean
}

const TableOfContents: FC<TableOfContentsProps> = (props) => {
  const { title, isOrdered, children } = props

  return (
    <nav className={ styles.tableOfContents }>
      <div className={ styles.title }>
        { title }
      </div>
      <div className={ styles.content }>
        <List
          theme='table-of-contents'
          isOrdered={ isOrdered }
        >
          { children }
        </List>
      </div>
    </nav>
  )
}

export default TableOfContents
